import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from "react-oidc-context";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import {NextUIProvider} from "@nextui-org/system";
let subdomain = window.location.hostname.split('.')[0];
// const appIdsMap = JSON.parse(process.env.REACT_APP_APPIDS || "{}");
// const APP_ID = appIdsMap[subdomain] || process.env.REACT_APP_DEFAULT_APPID || null;

const userPoolIds = {
  'chillihouse': 'eu-west-2_93bfdfXn5',
  'masalakitchen': 'eu-west-2_GfCgcHl74',
  'popularpizza': 'eu-west-2_sRyy4cnhT',
  'speedopizza': 'eu-west-2_vXq5sdmUg',
  'grillanddestroy': 'eu-west-2_UmwI5iQne',
  'kungpaopanda': 'eu-west-2_LO9TWfAoQ'
};
const clientIds = {
  'chillihouse': '2870hfen7mtbjhbrqt7nanul9r',
  'masalakitchen': '6rhte9j81jn1vt3ie77lqng29o',
  'popularpizza': 'feq9q6us3k6ibo18l9iecr9h7',
  'speedopizza': '26vhrcc0139h4r65han3md9ih1',
  'grillanddestroy': '6ckogemodpfu4qtcvc72vmhdo',
  'kungpaopanda': '5486olln1m9g89bd22t8kmrgq1'
};

let redirectURI = `https://${subdomain}.admin.grubify.co.uk`;
let userPool = userPoolIds[subdomain];

let appIdsMap = {};
try {
  appIdsMap = JSON.parse(process.env.REACT_APP_APPIDS || "{}");
} catch (e) {
  console.error("❌ Invalid REACT_APP_APPIDS:", e);
}



const APP_ID = appIdsMap[subdomain] || process.env.REACT_APP_DEFAULT_APPID || null;




const cognitoAuthConfig = {
  authority: `https://cognito-idp.eu-west-2.amazonaws.com/${userPool}`, // changes based on user pool/restaurant
  client_id: clientIds[subdomain],
  redirect_uri: redirectURI,
  response_type: "code",
  scope: "profile openid email",
  onSigninCallback: (_user) => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },      
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 <React.StrictMode>
    <NextUIProvider> 
  <AuthProvider {...cognitoAuthConfig}>
    <Router>
        <Routes>
          <Route path="/login" element={<App APP_ID={APP_ID} key={Date.now()} />} />
          <Route path="/*" element={<App APP_ID={APP_ID} key={Date.now()} />} />
        </Routes>
     </Router>
    </AuthProvider>
    </NextUIProvider>
  </React.StrictMode>  
);
